export enum RoleType {
  Owner = 1,
  PrimaryResident = 2,
  SecondaryResident = 3,
  RentalAgent = 4,
  OwnerCommittee = 5,
}

export enum UserLogin {
  Approver = 'approver',
  Admin = 'admin',
  Searcher = 'searcher',
  ViewPdf = 'pdf',
  Manager = 'gotoplan',
  Other = 'user_login',
}

export interface Role {
  roleId: number;
  name: string;
}
